var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedCallIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3803 25.3532C25.0763 26.8028 26.0251 28.1615 27.2266 29.3631C28.4282 30.5646 29.7869 31.5134 31.2365 32.2094C31.3612 32.2693 31.4235 32.2992 31.5024 32.3222C31.7828 32.404 32.127 32.3453 32.3644 32.1752C32.4313 32.1274 32.4884 32.0702 32.6027 31.9559C32.9523 31.6063 33.1271 31.4315 33.3029 31.3172C33.9658 30.8862 34.8204 30.8862 35.4833 31.3172C35.6591 31.4315 35.8339 31.6063 36.1835 31.9559L36.3783 32.1508C36.9098 32.6822 37.1755 32.948 37.3198 33.2333C37.6069 33.8009 37.6069 34.4712 37.3198 35.0387C37.1755 35.3241 36.9098 35.5898 36.3783 36.1213L36.2207 36.2789C35.6911 36.8085 35.4263 37.0733 35.0662 37.2756C34.6667 37.5 34.0462 37.6614 33.588 37.66C33.1751 37.6588 32.8928 37.5787 32.3284 37.4185C29.295 36.5575 26.4326 34.933 24.0447 32.545C21.6567 30.1571 20.0322 27.2947 19.1712 24.2613C19.011 23.6969 18.9309 23.4146 18.9297 23.0017C18.9283 22.5435 19.0897 21.923 19.3141 21.5235C19.5164 21.1634 19.7812 20.8986 20.3108 20.369L20.4684 20.2114C20.9999 19.6799 21.2656 19.4142 21.551 19.2699C22.1185 18.9828 22.7888 18.9828 23.3564 19.2699C23.6417 19.4142 23.9075 19.6799 24.4389 20.2114L24.6338 20.4062C24.9834 20.7559 25.1582 20.9307 25.2725 21.1064C25.7035 21.7693 25.7035 22.6239 25.2725 23.2868C25.1582 23.4626 24.9834 23.6374 24.6338 23.987C24.5195 24.1013 24.4623 24.1584 24.4145 24.2253C24.2445 24.4627 24.1858 24.807 24.2675 25.0873C24.2905 25.1662 24.3204 25.2285 24.3803 25.3532Z",
    stroke: "#0F47C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F7F9FF",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedCallIc);
export default __webpack_public_path__ + "static/media/FeaturedCall_ic.66b7dd91.svg";
export { ForwardRef as ReactComponent };